export default __webpack_public_path__ + "a86fd85ca23b9e4adb1e03751d42bec0.png";